import React from 'react';
import { Form } from 'react-bootstrap';
import ComboBox from './ComboBox';

function ComboBoxField({ field, value, on_change }) {
	return (
		<Form.Group className="admin-form-group">
			<Form.Label className="admin-form-label">{field.label}</Form.Label>
			<ComboBox
				value={value}
				options={field.options}
				on_change={function(val) { return on_change(field.key, val); }}
				className="admin-form-control"
			/>
		</Form.Group>
	);
}

export default ComboBoxField;
